import React from "react";
import { connect } from "react-redux";

import { EntityTypeSupportingGroups } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { FormItem } from "@mapmycustomers/ui";

import GroupsSelection from "@app/component/GroupsSelection";
import { getGroupsForEntity } from "@app/store/groups";
import { RootState } from "@app/store/rootReducer";

interface GroupsFieldProps {
  disabled?: boolean;
  entityType: EntityTypeSupportingGroups;
  field: IField;
  required?: boolean;
}

const GroupsField = ({
  disabled,
  entityType,
  field,
  groups,
  required,
}: GroupsFieldProps & ReturnType<typeof mapStateToProps>) => {
  return (
    <FormItem
      label={field.displayName}
      name={field.name}
      required={required}
      rules={[{ required }]}
      showLabel={false}
      valuePropName="selectedGroupIds"
    >
      <GroupsSelection
        createGroupPosition="top"
        disabled={disabled}
        editableGroupsOnly
        entityType={entityType}
        groups={groups}
        label={field.displayName}
        required={required}
      />
    </FormItem>
  );
};

const mapStateToProps = (state: RootState, { entityType }: GroupsFieldProps) => ({
  groups: getGroupsForEntity(state, entityType),
});

export default connect(mapStateToProps)(GroupsField);
